// import utils from '../common/util';
// import * as cmpDataContainer from './cmp-data-container';

const cmpStatCards = {
    component: null,

    /**
     * Initialise the component
     * @param element
     */
    init: function (element)
    {
        const _ = this;

		_.element = element;
        _.cards = document.getElementsByClassName('stat_cards__item');

        _.onClickEvent();
    },

    /**
     * Set on click events for each button
     */
    onClickEvent: function ()
    {
        const _ = this;

        for(let card of _.cards)
        {
            card.addEventListener('click', () =>
            {
                let overtimeType = card.getAttribute('data-overtime-type').toLowerCase().replace(' ', '');

                let rows = document.getElementsByClassName(overtimeType);

                for(let row of rows)
                {
                    row.classList.toggle('inactive');
                }
                card.classList.toggle('inactive');
            })
        }

        // element.addEventListener('click', () =>
        // {
            // _.classList.add('inactive');

            // collect variables from the data container object and clicked button
            // Object.assign(_, cmpDataContainer.default.collectVariables());
            // _.playType = element.getAttribute('data-play-type');

    //     })
    },
}

export default cmpStatCards;
